import Vue from 'vue'
import VueRouter from 'vue-router'

// fillform
import fillform from '@main/fillform/fillform'

// interview
import book_interview from '@main/interview/book'
import interview from '@main/interview/interview'
import interview_result from '@main/interview/result'
import interview_pass from '@main/interview/pass'

// pso
import pso from '@main/pso/pso'

// tpg
import book_tpg from '@main/tpg/book'
import tpg from '@main/tpg/tpg'
import tpg_result from '@main/tpg/result'

// demo
import book_demo from '@main/demo/book'
import demo from '@main/demo/demo'
import demo_result from '@main/demo/result'

// onboarding
import personal_profile from '@main/onboarding/personal_profile'
// onboarding children
import personal_in from '@main/onboarding/personal_in'
import personal_qa from '@main/onboarding/personal_qa'
import payment from '@main/onboarding/payment'
import on_board from '@main/onboarding/on_board'
import sign_sa from '@main/onboarding/sign_sa'
import info_pre from '@main/onboarding/info_pre'

// forgot_password
import forgot_password_step1 from '@main/forgot_password/forgot_password_step1'
import forgot_password_step2 from '@main/forgot_password/forgot_password_step2'
import forgot_password_step3 from '@main/forgot_password/forgot_password_step3'
import forgot_password_step4 from '@main/forgot_password/forgot_password_step4'

// other
import pending from '@main/other/pending'
import login_status from '@main/other/login_status'
import loading from '@main/other/loading'
import online_pending from '@main/other/online_pending'
import online_failed from '@main/other/online_failed'
import congratulations from '@main/other/congratulations'
import personal_profile_information from '@main/onboarding/personal_in'
import resetcode from '@main/other/resetcode'
import login from '@main/other/login'
import FAQ from '@main/other/FAQ'
import get_started from '@main/other/get_started'
import privacy_policy from '@main/other/privacy_policy'
import upload from '@main/other/upload'

import upload_img from '@common/upload_img'
import zoom from '@common/zoom'
import ac from '@common/ac'
import mypage from '@common/mypage'

Vue.use(VueRouter)

const steps = [
  ['fillform'],
  ['book_interview', 'interview', 'interview_result', 'interview_pass'],
  ['pso'],
  ['book_tpg', 'tpg', 'tpg_result', 'book_demo', 'demo', 'demo_result'],
  [
    'personal_profile',
    'personal_in',
    'personal_qa',
    'payment',
    'on_board',
    'sign_sa',
    'info_pre',
    'online_pending',
    'online_failed',
    'get_started'
  ]
]

const routes = [
  // fillform
  {
    path: '/fillform',
    name: 'fillform',
    component: fillform,
    meta: { gtm: 'MyCustomValue' }
  },
  // interview
  {
    path: '/book_interview',
    name: 'book_interview',
    component: book_interview
  },
  {
    path: '/interview',
    name: 'interview',
    component: interview,
    meta: { gtm: 'MyCustomValue' }
  },
  {
    path: '/interview_result',
    name: 'interview_result',
    component: interview_result
  },
  {
    path: '/interview_pass',
    name: 'interview_pass',
    component: interview_pass
  },
  // pso
  {
    path: '/pso',
    name: 'pso',
    component: pso
  },
  // tpg
  {
    path: '/book_tpg',
    name: 'book_tpg',
    component: book_tpg
  },
  {
    path: '/tpg',
    name: 'tpg',
    component: tpg
  },
  {
    path: '/tpg_result',
    name: 'tpg_result',
    component: tpg_result
  },
  // demo
  {
    path: '/book_demo',
    name: 'book_demo',
    component: book_demo
  },
  {
    path: '/demo',
    name: 'demo',
    component: demo
  },
  {
    path: '/demo_result',
    name: 'demo_result',
    component: demo_result
  },
  // onboarding
  {
    path: '/personal_profile',
    name: 'personal_profile',
    component: personal_profile,
    children: [
      {
        path: '/personal_profile/personal_in', // 基础信息
        name: 'personal_in',
        component: personal_in
      },
      {
        path: '/personal_profile/personal_qa', // 资质认证
        name: 'personal_qa',
        component: personal_qa
      },
      {
        path: '/personal_profile/payment', // 支付方式
        name: 'payment',
        component: payment
      },
      {
        path: '/personal_profile/on_board', //on_board
        name: 'on_board',
        component: on_board
      },
      {
        path: '/personal_profile/sign_sa', //签署sa
        name: 'sign_sa',
        component: sign_sa
      },
      {
        path: '/personal_profile/info_pre',
        name: 'info_pre',
        component: info_pre
      }
    ]
  },
  // online_pending
  {
    path: '/online_pending',
    name: 'online_pending',
    component: online_pending
  },
  // online_failed
  {
    path: '/online_failed',
    name: 'online_failed',
    component: online_failed
  },
  // forgot_password
  {
    path: '/forgot_password_step1',
    name: 'forgot_password_step1',
    component: forgot_password_step1
  },
  {
    path: '/forgot_password_step2',
    name: 'forgot_password_step2',
    component: forgot_password_step2
  },
  {
    path: '/forgot_password_step3',
    name: 'forgot_password_step3',
    component: forgot_password_step3
  },
  {
    path: '/forgot_password_step4',
    name: 'forgot_password_step4',
    component: forgot_password_step4
  },
  {
    path: '/',
    name: 'rigister_init',
    component: loading
  },
  {
    path: '/rigister',
    name: 'rigister',
    component: loading
  },
  {
    path: '/pending',
    name: 'pending',
    component: pending
  },
  {
    path: '/congratulations',
    name: 'congratulations',
    component: congratulations
  },
  {
    path: '/login_status',
    name: 'login_status',
    component: login_status
  },
  {
    path: '/personal_profile_information',
    name: 'personal_profile_information',
    component: personal_profile_information
  },
  {
    path: '/resetcode',
    name: 'resetcode',
    component: resetcode
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/POLICY',
    name: 'POLICY',
    component: FAQ
  },
  {
    path: '/FAQ',
    name: 'FAQ',
    component: FAQ
  },
  {
    path: '/payment',
    name: 'payment',
    component: payment
  },
  {
    path: '/get_started',
    name: 'get_started',
    component: get_started
  },
  {
    path: '/privacy_policy',
    name: 'privacy_policy',
    component: privacy_policy
  },
  {
    path: '/upload_img',
    name: 'upload_img',
    component: upload_img
  },
  {
    path: '/zoom',
    name: 'zoom',
    component: zoom
  },
  {
    path: '/ac',
    name: 'ac',
    component: ac
  },
  {
    path: '/mypage',
    name: 'mypage',
    component: mypage
  },
  {
    path: '/upload',
    name: 'upload',
    component: upload
  }
]

const setSteps = routes => {
  for (let route of routes) {
    steps.map((item, index) => {
      if (item.includes(route.name)) {
        route.meta = { ...route.meta, ...{ step: index + 1 } }
      }
    })

    if (route.children) {
      setSteps(route.children)
    }
  }
}

setSteps(routes)

console.log(routes)
export default new VueRouter({
  routes
})



// WEBPACK FOOTER //
// ./src/router/index.js